import React from "react";

export default function BookModal({ setBookModal, data }) {
  return (
    <div
      _ngcontent-ng-c1703479958=""
      id="fancyPLModal"
      tabIndex={-1}
      aria-labelledby="fancyPLModalLabel"
      className="modal fade show"
      aria-modal="true"
      role="dialog"
      style={{ display: "block" }}
    >
      <div _ngcontent-ng-c1703479958="" className="modal-dialog modal-sm">
        <div _ngcontent-ng-c1703479958="" className="modal-content">
          <div
            _ngcontent-ng-c1703479958=""
            className="modal-header bet-slip-head"
          >
            <h1
              _ngcontent-ng-c1703479958=""
              id="exposureModalLabel"
              className="modal-title"
            >
              Book
            </h1>
            <button
              _ngcontent-ng-c1703479958=""
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              className="close"
              onClick={() => setBookModal(false)}
            >
              <span _ngcontent-ng-c1703479958="" aria-hidden="true">
                ×
              </span>
            </button>
          </div>
          <div
            _ngcontent-ng-c1703479958=""
            className="modal-body scrollBodyRule"
          >
            <div _ngcontent-ng-c1703479958="" className="book-popup">
              <table
                _ngcontent-ng-c1703479958=""
                className="table table-bordered fancybooktable"
              >
                <thead
                  _ngcontent-ng-c1703479958=""
                  className="border fancyhead"
                >
                  <tr _ngcontent-ng-c1703479958="">
                    <th
                      _ngcontent-ng-c1703479958=""
                      className="border text-center"
                    >
                      Run
                    </th>
                    <th
                      _ngcontent-ng-c1703479958=""
                      className="border text-center"
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody _ngcontent-ng-c1703479958="">
                  {data?.map((item) => (
                    <tr
                      _ngcontent-ng-c1703479958=""
                      className={item?.exposure > 0 ? "backrow" : "layrow"}
                    >
                      <td _ngcontent-ng-c1703479958="" className="text-center">
                        {item.selectionId}
                      </td>
                      <td _ngcontent-ng-c1703479958="" className="text-center">
                        {item?.exposure}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
